import Model from './Model';

export default class Signup extends Model {
  // eslint-disable-next-line class-methods-use-this
  resource() {
    return 'signups';
  }
}
